<!--
  Created 15.10.2023
  Simple Activity Icon component
  Returns an icon based on the activity type
-->
<template>
  <template v-if="props.type === 'note'">
    <DocumentTextIcon
      :class="classes"
      aria-hidden="true" />
  </template>
  <template v-else-if="props.type === 'call'">
    <PhoneIcon
      :class="classes"
      aria-hidden="true" />
  </template>
  <template v-else-if="props.type === 'email'">
    <EnvelopeIcon
      :class="classes"
      aria-hidden="true" />
  </template>
  <template v-else-if="props.type === 'meeting'">
    <CalendarDaysIcon
      :class="classes"
      aria-hidden="true" />
  </template>
  <template v-else>
    <QuestionMarkCircleIcon
      :class="classes"
      aria-hidden="true" />
  </template>
</template>

<script setup>

import {
  DocumentTextIcon, PhoneIcon, EnvelopeIcon, CalendarDaysIcon, QuestionMarkCircleIcon,
} from '@heroicons/vue/24/solid';

const props = defineProps({
  type: {
    type: String,
    required: true,
    default: 'note',
  },
  classes: {
    type: String,
    required: false,
    default: 'h-5 w-5 text-gray-400',
  },
});

</script>
